module.exports = __webpack_public_path__ + "fbbeeaf25d7ab6814af413dd68c729d0.MP3";